







































































import { Vue, Component, Prop } from 'nuxt-property-decorator'
import { defineComponent } from '@nuxtjs/composition-api'
import BlockListItem from './BlockListItem.vue'
import BlockBreadCrumbs from '@/components/BlockBreadCrumbs.vue'
import BlockRequisitesItem from '@/components/BlockRequisitesItem.vue'
import BlockText from '@/components/BlockText.vue'
import Link from '@/components/Link.vue'

@Component
class BlockRequisites extends Vue {
  @Prop() readonly title: string = ''
  @Prop() readonly lastModified: string = ''
  @Prop() readonly list: ReadonlyArray<any> = []
  @Prop() readonly isReverse: boolean = false
  @Prop({ default: false }) readonly needBreadCrumbs: Boolean = false
  @Prop() readonly text: string = ''
  @Prop() readonly docUrl: String = ''
  @Prop() readonly buttonText: String = ''
  static options: any
}

export default defineComponent({
  name: 'BlockRequisites',
  components: {
    BlockBreadCrumbs,
    BlockRequisitesItem,
    BlockListItem,
    BlockText,
    Link,
  },
  props: BlockRequisites.options.props,

  setup() {
    return {}
  },
})
